import { cn } from '@neo-agents/ui'

interface RobotLogoProps {
  className?: string
  animated?: boolean
  backgroundColor?: string
  foregroundColor?: string
  withShadow?: boolean
  title?: string
}

export function RobotLogo({
  className,
  animated = false,
  backgroundColor = 'var(--main)',
  foregroundColor = '#000000',
  withShadow = false,
  title = 'Robolab X',
}: RobotLogoProps) {
  return (
    <div
      className={cn('inline-flex items-center justify-center overflow-hidden rounded-lg border-2', className)}
      style={withShadow ? { filter: 'drop-shadow(0 12px 12px rgba(0, 0, 0, 0.15))' } : undefined}
    >
      <svg
        width="320"
        height="320"
        viewBox="0 0 320 320"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        role={title ? 'img' : 'presentation'}
      >
        {title ? <title>{title}</title> : null}
        <defs></defs>
        <g opacity="1">
          <rect x="0" y="0" width="320" height="320" rx="0" fill={backgroundColor}/>
          <rect x="0.5" y="0.5" width="319" height="319" rx="0" stroke="rgba(255, 255, 255, 0.2)" strokeWidth="1" fill="none"/>
          <g transform="translate(160, 160) rotate(0) translate(-120, -120) scale(10)">
            <path fill={foregroundColor} d="M13.5 2c0 .444-.193.843-.5 1.118V5h5a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h5V3.118A1.5 1.5 0 1 1 13.5 2ZM6 7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6Zm-4 3H0v6h2v-6Zm20 0h2v6h-2v-6ZM9 14.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3Zm6 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3Z"/>
          </g>
          {animated ? (
            <>
              <rect x="122" y="133" width="26" height="2" rx="1" fill={backgroundColor} opacity="0">
                <animate attributeName="opacity" values="0;0;1;1;0;0" dur="4.6s" repeatCount="indefinite" />
                <animate attributeName="y" values="133;133;126;126;133;133" dur="4.6s" repeatCount="indefinite" />
                <animate attributeName="height" values="2;2;16;16;2;2" dur="4.6s" repeatCount="indefinite" />
              </rect>
              <rect x="172" y="133" width="26" height="2" rx="1" fill={backgroundColor} opacity="0">
                <animate attributeName="opacity" values="0;0;1;1;0;0" dur="4.6s" repeatCount="indefinite" />
                <animate attributeName="y" values="133;133;126;126;133;133" dur="4.6s" repeatCount="indefinite" />
                <animate attributeName="height" values="2;2;16;16;2;2" dur="4.6s" repeatCount="indefinite" />
              </rect>
            </>
          ) : null}
        </g>
      </svg>
    </div>
  )
}
